"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Display;
(function (Display) {
    Display["Inline"] = "ty-display-inline";
    Display["Block"] = "ty-display-block";
    Display["Flex"] = "ty-display-flex";
    Display["InlineBlock"] = "ty-display-inline-block";
    Display["InlineFlex"] = "ty-display-inline-flex";
    Display["None"] = "ty-display-none";
    Display["Initial"] = "ty-display-initial";
    Display["Inherit"] = "ty-display-inherit";
})(Display = exports.Display || (exports.Display = {}));
